// Keys that must never reach the dataLayer (and therefore GA4/GTM).
// This is the one place to edit if the list needs to grow later -
// nothing else in the tracking module should need to change.
const PII_BLOCKLIST = [
    'firstName',
    'lastName',
    'fullName',
    'email',
    'phone',
    'phoneNr',
    'phoneNumber',
    'phoneCode',
    'address',
    'city',
    'postalCode',
    'zip',
    'customer',
];

export default PII_BLOCKLIST;
